import React from 'react'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

const StyledWhiteTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.common.white
    },
    '&:hover fieldset': {
      borderColor: theme.palette.common.white
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.common.white
    }
  },
  '& .MuiOutlinedInput-input': {
    color: theme.palette.common.white
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.common.white
  },
  '& .MuiSelect-icon': {
    color: theme.palette.common.white
  }
}))

function BaseTextField({
  readOnly = false,
  withT = true,
  white = false,
  select = false,
  InputProps = {},
  ...props
}) {
  const { t } = useTranslation()

  if (white) {
    return (
      <StyledWhiteTextField
        variant='outlined'
        margin='normal'
        fullWidth
        autoComplete='off'
        select={select}
        InputProps={{
          readOnly,
          ...InputProps
        }}
        {...props}
      />
    )
  }

  if (readOnly && !select) {
    return (
      <TextField
        variant='outlined'
        margin='normal'
        fullWidth
        autoComplete='off'
        InputProps={{
          readOnly,
          ...InputProps
        }}
        label={props.label}
        value={withT ? t(props.value) : props.value}
        {...props}
      />
    )
  }

  if (readOnly && select) {
    return (
      <TextField
        variant='outlined'
        margin='normal'
        fullWidth
        autoComplete='off'
        InputProps={{
          readOnly,
          ...InputProps
        }}
        label={props.label}
        select={select}
        {...props}
      />
    )
  }

  return (
    <TextField
      variant='outlined'
      margin='normal'
      fullWidth
      autoComplete='off'
      select={select}
      InputProps={{
        ...InputProps
      }}
      {...props}
    />
  )
}

BaseTextField.propTypes = {
  readOnly: PropTypes.bool,
  withT: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.bool
  ]),
  white: PropTypes.bool,
  select: PropTypes.bool,
  InputProps: PropTypes.object,
  props: PropTypes.object
}

export default BaseTextField
